/* Flair mobile bottom nav
   Extracted from layout/theme.liquid. The legacy second nav script that used
   to sit alongside this one has been removed: it targeted
   .flair-mobile-nav__item and #mobile-cart-count, neither of which exist in
   the current markup, and it ran setInterval() every 2 seconds for the whole
   life of every page session doing nothing.

   CART BUTTON - READ THIS BEFORE CHANGING findCartDrawer()
   The cart button used to look for '.flair-shared-cart cart-drawer-component'.
   No element with class flair-shared-cart is rendered by this theme, so that
   selector returned null and tapping Cart in the mobile bottom bar opened
   nothing at all. It now falls back to any cart-drawer-component on the page,
   and to the header cart trigger, so it keeps working even if the drawer is
   moved or re-wrapped.

   CART BUTTON - WHY IT CALLS closeHeaderMenu() AND NOT toggleHeaderMenu()
   The cart button used to call toggleHeaderMenu() unconditionally, which
   clicks #flairMenuBtn. That is a toggle, so when the slide-out menu was
   already closed - the normal case - tapping Cart OPENED the menu and then
   opened the drawer on top of it. Closing the drawer left the shopper looking
   at a menu they never asked for. closeHeaderMenu() only clicks when the menu
   is actually open.

   CART EVENTS - DEBOUNCED, ONE REQUEST IN FLIGHT
   Different parts of this theme dispatch cart:updated, cart:update and
   cart:refresh, and the cart-bubble MutationObserver fires on the same
   re-render. Bound directly to syncNavCart that produced three or four
   simultaneous /cart.js requests per cart change. They now go through
   queueNavCartSync: 150ms debounce, one request in flight, and a single
   trailing re-run if anything asked again while that request was open.

   NULL SAFETY
   [data-nav-main] and [data-nav-menu] are read once and then touched from
   observers and callbacks. They are guarded through setPanels() so a markup
   change in the nav cannot throw and take the cart badge and CTA down with it. */
(function () {
  var nav = document.querySelector('.flair-mobile-nav');
  if (!nav) return;
  var cta = document.getElementById('flairNavCta');
  var badge = document.getElementById('flairNavBadge');
  var cartBadge = nav.querySelector('[data-nav-cart-badge]');
  var cartCount = 0;

  var main = nav.querySelector('[data-nav-main]');
  var menu = nav.querySelector('[data-nav-menu]');
  var flairDropdown = document.getElementById('flairMenuDropdown');

  function setPanels(mainHidden, menuHidden) {
    if (main) main.hidden = mainHidden;
    if (menu) menu.hidden = menuHidden;
  }

  function returnMain() {
    if (!main) return;
    main.classList.add('is-returning');
    setTimeout(function () {
      main.classList.remove('is-returning');
    }, 350);
  }

  function cartRoute(path) {
    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    return root.replace(/\/$/, '') + path;
  }

  function isMenuOpen() {
    return !!flairDropdown && flairDropdown.classList.contains('is-open');
  }

  function toggleHeaderMenu(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    var headerMenuBtn = document.getElementById('flairMenuBtn');
    if (headerMenuBtn) headerMenuBtn.click();
  }

  function closeHeaderMenu() {
    if (isMenuOpen()) toggleHeaderMenu();
  }

  function findCartDrawer() {
    return (
      document.querySelector('.flair-shared-cart cart-drawer-component') ||
      document.querySelector('cart-drawer-component')
    );
  }

  function openCart() {
    var drawer = findCartDrawer();
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    // Fall back to the header trigger, which owns the same open action.
    var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) {
      trigger.click();
      return true;
    }
    // Last resort: never leave the shopper with a dead button.
    window.location.href = cartRoute('/cart');
    return false;
  }

  var openMenuBtn = nav.querySelector('[data-nav-menu-open]');
  if (openMenuBtn) openMenuBtn.addEventListener('click', toggleHeaderMenu);

  var closeMenuBtn = nav.querySelector('[data-nav-close]');
  if (closeMenuBtn) closeMenuBtn.addEventListener('click', toggleHeaderMenu);

  var cartBtn = nav.querySelector('[data-nav-cart]');
  if (cartBtn) {
    cartBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      closeHeaderMenu();
      openCart();
    });
  }

  // The bar mirrors the drawer state: icon options while the menu is
  // open, contextual CTA otherwise (covers overlay/outside closes too)
  if (flairDropdown && 'MutationObserver' in window) {
    new MutationObserver(function () {
      var open = isMenuOpen();
      nav.classList.toggle('menu-open', open);
      if (isStatic) return; // icon row stays put; only the burger/X icon swaps
      if (pdpSync) {
        pdpSync();
        return;
      } // PDP: state depends on scroll position
      if (!open && main && main.hidden) returnMain();
      setPanels(open, !open);
    }).observe(flairDropdown, { attributes: true, attributeFilter: ['class'] });
  }

  // Contextual CTA: mirrors the page's own buy button when there is one,
  // otherwise Checkout (cart has items) or Get Started
  var pageAtc = document.getElementById('addToCartBtn') || document.querySelector('[data-bundle-atc]');

  // Blog pages always promote the starter set with Get Started
  var isBlog =
    document.body.classList.contains('template-article') ||
    document.body.classList.contains('template-blog');

  // PDPs: nav always visible - icon row until the shopper scrolls past
  // the on-page buy button, then it swaps to the Add to Cart CTA
  var pdpSync = null;
  if (pageAtc && 'IntersectionObserver' in window) {
    var scrolledPastAtc = false;
    pdpSync = function () {
      if (nav.classList.contains('menu-open')) {
        setPanels(true, false);
        return;
      }
      if (scrolledPastAtc && main && main.hidden) returnMain();
      setPanels(!scrolledPastAtc, scrolledPastAtc);
    };
    new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        scrolledPastAtc = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        pdpSync();
      },
      { threshold: 0 }
    ).observe(pageAtc);
    pdpSync();
  }

  // Non-PDP, non-blog pages: the icon row IS the nav (no CTA state)
  var isStatic = !pageAtc && !isBlog;
  if (isStatic) {
    nav.classList.add('flair-mobile-nav--static');
    setPanels(true, false);
  }

  function syncCta() {
    if (!cta) return;
    if (pageAtc) {
      var txt = (pageAtc.textContent || '').replace(/\s+/g, ' ').trim();
      var soldOut = pageAtc.disabled && txt.toLowerCase().includes('sold');
      cta.textContent = soldOut ? 'Sold out' : 'Add to Cart';
      cta.disabled = soldOut;
    } else if (isBlog) {
      cta.textContent = 'Get Started';
      cta.disabled = false;
    } else if (cartCount > 0) {
      cta.textContent = 'Checkout';
      cta.disabled = false;
    } else {
      cta.textContent = 'Get Started';
      cta.disabled = false;
    }
  }

  if (cta) {
    cta.addEventListener('click', function () {
      if (pageAtc) {
        if (pageAtc.disabled) {
          var step = document.querySelector('.bundle-picker-step') || pageAtc;
          step.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          pageAtc.click();
        }
      } else if (!isBlog && cartCount > 0) {
        window.location.href = cartRoute('/checkout');
      } else {
        window.location.href = cartRoute('/products/starter-set');
      }
    });
  }

  if (pageAtc && 'MutationObserver' in window) {
    new MutationObserver(syncCta).observe(pageAtc, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });
  }

  // ---- Cart count sync -----------------------------------------------------
  var cartSyncTimer = null;
  var cartSyncInFlight = false;
  var cartSyncPending = false;

  function syncNavCart() {
    if (cartSyncInFlight) {
      cartSyncPending = true;
      return;
    }
    cartSyncInFlight = true;

    fetch(cartRoute('/cart.js'), { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        cartCount = c.item_count || 0;
        var label = cartCount > 9 ? '9+' : cartCount;
        if (badge) {
          badge.hidden = cartCount === 0;
          badge.textContent = label;
        }
        if (cartBadge) {
          cartBadge.hidden = cartCount === 0;
          cartBadge.textContent = label;
        }
        syncCta();
      })
      .catch(function () {})
      .then(function () {
        cartSyncInFlight = false;
        if (cartSyncPending) {
          cartSyncPending = false;
          queueNavCartSync();
        }
      });
  }

  function queueNavCartSync() {
    if (cartSyncTimer) clearTimeout(cartSyncTimer);
    cartSyncTimer = setTimeout(function () {
      cartSyncTimer = null;
      syncNavCart();
    }, 150);
  }

  syncNavCart();

  var bubble = document.querySelector('cart-icon .cart-bubble__text-count');
  if (bubble && 'MutationObserver' in window) {
    new MutationObserver(queueNavCartSync).observe(bubble, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  ['cart:updated', 'cart:update', 'cart:refresh'].forEach(function (name) {
    document.addEventListener(name, queueNavCartSync);
  });

  syncCta();
})();
